import { CircleAlert, CircleCheck, Clock3 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { PackagingItemsOrgStats } from '@/shared/hooks/api/packagingItemsOverview'
import { FunnelStatItem } from './FunnelStatItem'
import { formatStatFraction } from './packagingSupplierStats'

type PackagingItemsStatsRowProps = {
  stats: PackagingItemsOrgStats
}

export function PackagingItemsStatsRow({ stats }: PackagingItemsStatsRowProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <div className='grid shrink-0 gap-2 sm:grid-cols-2 lg:grid-cols-3'>
      <FunnelStatItem
        label={t('stats.packagingItemsInDraft')}
        tooltip={t('stats.packagingItemsInDraftTooltip')}
        icon={
          <Clock3
            className='size-4 text-amber-600 dark:text-amber-500'
            aria-hidden
          />
        }
        percent={
          stats.total === 0
            ? 0
            : Math.round((stats.inDraft / stats.total) * 100)
        }
        description={formatStatFraction(stats.inDraft, stats.total)}
      />
      <FunnelStatItem
        label={t('stats.packagingItemsComplete')}
        tooltip={t('stats.packagingItemsCompleteTooltip')}
        icon={
          <CircleCheck
            className='size-4 text-green-600 dark:text-green-500'
            aria-hidden
          />
        }
        percent={stats.completePercent}
        description={formatStatFraction(stats.complete, stats.total)}
      />
      <FunnelStatItem
        label={t('stats.packagingItemsWithRedFlags')}
        tooltip={t('stats.packagingItemsWithRedFlagsTooltip')}
        icon={
          <CircleAlert className='size-4 text-destructive' aria-hidden />
        }
        percent={
          stats.total === 0
            ? 0
            : Math.round((stats.withRedFlags / stats.total) * 100)
        }
        description={formatStatFraction(stats.withRedFlags, stats.total)}
      />
    </div>
  )
}
